@if (bookData) {
<div class="book-card" (click)="redirect();">
  <div class="book-cover">

    @if(bookData.bookSaleCoverURL){
    <img [src]="bookData.bookSaleCoverURL" [alt]="'Capa do livro ' + bookData.bookTitle">
    }
    @else{
    <img [src]="bookData.coverImage" [alt]="'Capa do livro ' + bookData.bookTitle"
      onerror="this.onerror=null;this.src='https://placehold.co/400x600/e0e0e0/333?text=Capa+Indisponível';">
    }


  </div>
  <div class="book-info">
    <h3 class="book-title">{{ bookData.bookTitle || bookData.kitName }}</h3>
    <p class="book-author">Por: {{ bookData.autor }}</p>

    <div class="book-tags">
      @if (bookData.includesEbook) {
      <span class="tag ebook">Ebook</span>
      }
      @if (bookData.includesBook) {
      <span class="tag fisico">Físico</span>
      }
      @if (bookData.includesVideoAccess) {
      <span class="tag video">Videos</span>
      }
    </div>

    <div class="book-rating">
      @for (filled of stars; track $index) {
      <span class="star" [class.filled]="filled">&#9733;</span>
      }
    </div>
    <p class="book-price">{{ bookData.totalPrice | currency:'BRL' }}</p>
  </div>
</div>
}
@else{
<div class="book-card" (click)="redirect();">
  <app-loading-box [height]="'284'" [width]="'203'" [marginTop]="'0'"></app-loading-box>

  <div class="book-info">
    <app-loading-box [height]="'20'" [width]="'200'" [marginTop]="'7'"></app-loading-box>
    <p class="book-author"><app-loading-box [height]="'20'" [width]="'200'" [marginTop]="'7'"></app-loading-box></p>

    <div class="book-tags">
      <app-loading-box [height]="'15'" [width]="'40'" [marginTop]="'7'"></app-loading-box>
    </div>

    <div class="book-rating">
      @for (filled of stars; track $index) {
      <span class="star" [class.filled]="filled">&#9733;</span>
      }
    </div>
    <p class="book-price"> <app-loading-box [height]="'15'" [width]="'129'" [marginTop]="'7'"></app-loading-box></p>
  </div>
</div>
}